import { DITypes } from "@/core/@types/types";
import type { IToastNotification } from "@/core/composables/notification/types";
import { diContainer } from "@/core/di";

export const FINANCIAL_CATALOG_ERROR_MESSAGE =
  "Não foi possível carregar empresas e contas.";

/**
 * Isola a falha do catálogo nas telas em que ele é só um dos recursos
 * carregados em paralelo. Sem isso, uma rejeição derruba o `Promise.all`
 * inteiro e recursos independentes (DRE, centros de custo, adquirentes)
 * deixam de ser publicados.
 *
 * A falha continua visível: toast para o usuário e `companiesError` /
 * `accountsError` na store para quem quiser reagir. Quem depende do catálogo
 * para funcionar — como o drawer de regra de usuário — deve continuar
 * deixando a rejeição subir.
 *
 * Página e componentes filhos podem aguardar a mesma requisição da store e
 * recebem o mesmo erro; o toast sai uma vez por falha, não por consumidor.
 */
const notifiedErrors = new WeakSet<object>();

export const handleFinancialCatalogError = (error?: unknown) => {
  if (typeof error === "object" && error !== null) {
    if (notifiedErrors.has(error)) return [];
    notifiedErrors.add(error);
  }

  diContainer
    .get<IToastNotification<string>>(DITypes.NOTIFICATION)
    .showNotification(FINANCIAL_CATALOG_ERROR_MESSAGE, { type: "error" });

  return [];
};
